//
// Copyright 2025 DXOS.org
//

import { type ObjectId } from '@dxos/echo-schema';

// TODO(burdon): Move to artifact.
export const createArtifactElement = (id: ObjectId) => `<artifact id=${id} />`;
